export class DisMonthEntity{
    id:number;
    month:number;
    monthName:string;
    year:number;
    days:number

    constructor(){}
}